export const GET_CONTRACTS_FOR_REFERENCE_QUERY = `
  query GetContractsForReference($companyId: Int!) {
    contracts(where: { company_id: { _eq: $companyId } }, order_by: { created_at: desc }) {
      id
      firm_id
      firm_short_name
      contract_signing_date
      contract_description
      contract_subject {
        id
        name
      }
      scope_of_work {
        id
        name
      }
      work_status {
        id
        name
      }
      firm {
        id
        firm_name
        firm_short_name
      }
      # İş ekleme formu sözleşme dropdown'unda "mevcut iş" ipucu göstermek
      # icin — bir firmanin birden fazla sözlesmesi varsa hangi sözlesmenin
      # neyle ilgili olduğunu ayirt etmeye yarar (Task 2).
      jobs {
        id
        job_title
      }
    }
  }
`;

export const GET_CONTRACTS_QUERY = `
  query GetContracts($where: contracts_bool_exp = {}, $limit: Int, $offset: Int, $order_by: [contracts_order_by!] = [{ created_at: desc }]) {
    contracts_aggregate(where: $where) {
      aggregate { count }
    }
    contracts(where: $where, order_by: $order_by, limit: $limit, offset: $offset) {
      id
      contract_subject_id
      scope_of_work_id
      pricing_method_id
      work_status_id
      contract_signing_date
      invoice_issue_date
      auto_renewal
      renewal_period
      first_price_increase_period
      inflation_clause
      work_start_date
      work_started_without_contract
      protocol_start_date
      protocol_end_date
      comment
      contract_description
      contract_pdf_key
      protocol_pdf_key
      contract_pdf_size
      protocol_pdf_size
      company_id
      firm_id
      firm_short_name
      created_at
      updated_at
      contract_subject {
        id
        name
        is_project_based
      }
      scope_of_work {
        id
        name
      }
      pricing_method {
        id
        name
      }
      work_status {
        id
        name
      }
      company {
        id
        name
      }
      firm {
        id
        firm_name
        firm_short_name
      }
      jobs {
        id
        project_number
        job_title
        job_status
      }
      renewals(order_by: { renewal_end_date: desc }) {
        id
        renewal_start_date
        renewal_end_date
        description
        protocol_pdf_key
        protocol_pdf_size
        new_monthly_amount
        created_at
      }
    }
  }
`;

export const GET_CONTRACT_BY_ID_QUERY = `
  query GetContractById($id: Int!) {
    contracts_by_pk(id: $id) {
      id
      contract_subject_id
      scope_of_work_id
      pricing_method_id
      work_status_id
      contract_signing_date
      invoice_issue_date
      auto_renewal
      renewal_period
      first_price_increase_period
      inflation_clause
      work_start_date
      work_started_without_contract
      protocol_start_date
      protocol_end_date
      comment
      contract_description
      contract_pdf_key
      protocol_pdf_key
      contract_pdf_size
      protocol_pdf_size
      company_id
      firm_id
      firm_short_name
      created_at
      updated_at
      contract_subject {
        id
        name
        is_project_based
      }
      scope_of_work {
        id
        name
      }
      pricing_method {
        id
        name
      }
      work_status {
        id
        name
      }
      company {
        id
        name
      }
      firm {
        id
        firm_name
        firm_short_name
      }
    }
  }
`; 